<template>
  <b-row>
    <b-col cols="12">
      <collapse-admin :modulo-data="moduloData" />
    </b-col>
  </b-row>
</template>
<script>
import store from '@/store'
import moduloTreStore from '@/store/ModuloTrei/moduloTreStore'
import { BRow, BCol } from 'bootstrap-vue'
import CollapseAdmin from '@/views/App/Treinamentos/TreinamentosAdmin/collapseAdmin.vue'
import { onUnmounted } from '@vue/composition-api'
// eslint-disable-next-line import/extensions
import useModulosList from '@/views/App/Treinamentos/TreinamentosAdmin/useModulosList'

export default {
  components: {
    CollapseAdmin,
    BRow,
    BCol,
  },

  // setup() {
  //   const USER_APP_STORE_MODULE_NAME = 'app-modulo'
  //
  //   // Register module
  //   if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, moduloTreStore)
  //
  //   // Unregister on leave
  //   onUnmounted(() => {
  //     if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
  //   })
  //
  //   const {
  //     fetchUsers,
  //     tableColumns,
  //     perPage,
  //     totalRows,
  //     currentPage,
  //     refNewTable,
  //     moduloData,
  //     moduloRefresh,
  //
  //   } = useModulosList()
  //
  //   watch(moduloData, value => {
  //     console.log('watch', value)
  //   })
  //   return {
  //     fetchUsers,
  //     tableColumns,
  //     perPage,
  //     totalRows,
  //     currentPage,
  //     refNewTable,
  //     moduloData,
  //     moduloRefresh,
  //   }
  // },

  setup() {
    const USER_APP_STORE_MODULE_NAME = 'app-modulo'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, moduloTreStore)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const onSubmit = async () => {
      await refetchData()
    }

    const {
      moduloData,
      refetchData,
    } = useModulosList()

    return {
      onSubmit,
      moduloData,
      refetchData,
    }
  },

}
</script>
